import { sendExpandClickEvent } from "@shared/Analytics/content/link-click-analytics";

const AddAriaExpandToSubscriptions = () => {
  const allToggle = document.querySelectorAll<HTMLElement>("[name='subscription-showmore']");
  allToggle.forEach((toggle) => {
    const checkbox = toggle.querySelector("input");
    const contentId = `subscription-showmore-content-${toggle.dataset.id}`;
    const card = toggle.closest(".subscription-card");
    const content = card?.querySelector<HTMLElement>(`#${CSS.escape(contentId)}`);

    if (!checkbox || !content) {
      return;
    }

    toggle.setAttribute("role", "button");
    toggle.setAttribute("tabindex", "0");
    toggle.setAttribute("aria-controls", contentId);

    const updateAriaExpanded = (sendAnalytics = false) => {
      const expanded = checkbox.checked;
      const ariaLabel = expanded
        ? `Vis mindre informasjon om ${toggle.dataset.product}.`
        : toggle.dataset.showMoreText
          ? `${toggle.dataset.showMoreText}, ${toggle.dataset.product}.`
          : `Vis mer informasjon om ${toggle.dataset.product}.`;

      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggle.setAttribute("aria-label", ariaLabel);

      content.setAttribute("aria-hidden", expanded ? "false" : "true");
      content.toggleAttribute("inert", !expanded);

      if (sendAnalytics) {
        sendExpandClickEvent(ariaLabel, expanded);
      }
    };

    updateAriaExpanded();

    toggle.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    checkbox.addEventListener("change", () => updateAriaExpanded(true));
  });
};

export const bootstrapSubscription = () => {
  AddAriaExpandToSubscriptions();
};
